export default "__VITE_ASSET__BUdAwimu__"